export default "https://cdn-static.gokick.com/assets/c66ec253f0896645bf734992981ccce4219a90e3/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";